import { render, staticRenderFns } from "./EmailCampaignEditor.vue?vue&type=template&id=b1de952e"
import script from "./EmailCampaignEditor.vue?vue&type=script&lang=js"
export * from "./EmailCampaignEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports